// 汎用無限ループスライダー
//
// `.js-loop-slider` を見つけて、
//   - data-slider-speed / data-slider-gap → CSS 変数に反映
//   - viewport (= 親要素) 幅の 3 倍以上になるまで子要素を複製
//   - 元の 1 セット幅 (px) を `--slider-step` として注入
// する。あとは CSS 側で `translateX(calc(-1 * var(--slider-step)))` を回せば
// 原本→複製の継ぎ目で巻き戻り、シームレスにループする。
//
// クローン数が増えても 1 step は元の 1 セット分なので、見た目の流速は
// animation-duration (= --slider-speed) で一意に決まる。
export default () => {
  const init = () => {
    document.querySelectorAll('.js-loop-slider').forEach((track) => {
      if (track.dataset.sliderInit === '1') return;

      // data-* を CSS 変数に反映 (どちらか省略でも OK)
      const { sliderSpeed, sliderGap } = track.dataset;
      if (sliderSpeed) {
        track.style.setProperty('--slider-speed', `${sliderSpeed}s`);
      }
      if (sliderGap) {
        track.style.setProperty('--slider-gap', `${sliderGap}px`);
      }

      const originals = Array.from(track.children);
      if (originals.length === 0) return;

      const viewport = track.parentElement;
      if (!viewport) return;

      // 1 枚分の幅 (margin-right 込み) を測って原本セット幅を出す。
      // CSS で width が確定していれば画像のロードを待つ必要はない。
      const first = originals[0];
      const cs = window.getComputedStyle(first);
      const cardWidth =
        first.offsetWidth + parseFloat(cs.marginRight || '0');
      const originalSetWidth = originals.length * cardWidth;
      if (originalSetWidth <= 0) return;

      // viewport の 3 倍以上の track 幅になるまで複製。
      // 余裕を持たせておけば多少のリサイズでも端見えしない。
      const vw = viewport.clientWidth || window.innerWidth;
      const cloneSetsNeeded = Math.max(
        1,
        Math.ceil((vw * 3) / originalSetWidth)
      );

      for (let s = 0; s < cloneSetsNeeded; s++) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }

      track.style.setProperty('--slider-step', `${originalSetWidth}px`);
      track.dataset.sliderInit = '1';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
};
